/**
 * @file Builds the U.S.-citizen input that each profile schema shares.
 */
import type { Input, UpdateSchema } from "../types";

/**
 * Builds the U.S.-citizen input. A change to the answer clears the
 * U.S.-person answer through the caller's handler, then rebuilds the
 * schema around the new citizenship.
 */
const computeIsUsCitizenInput = (
  label: string,
  updateSchema: UpdateSchema,
): Input => {
  const { onIsUsCitizenChange } = updateSchema;

  /**
   * Clears the U.S.-person answer and refreshes the schema after the
   * citizenship answer changes.
   */
  const onChange = (): void => {
    if (onIsUsCitizenChange) {
      onIsUsCitizenChange();
    }

    updateSchema();
  };

  return {
    name: "isUsCitizen",
    label,
    required: true,
    inputProps: {
      onChange,
    },
  };
};

export default computeIsUsCitizenInput;
